var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "8px",
    viewBox: "0 0 16 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8296EE2D-F474-490C-B5BD-00C816DB936F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-44.000000, -297.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ruler",
    transform: "translate(44.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,0.666666667 L0,7.33333333 L0,8 L0.666666667,8 L15.3333333,8 L16,8 L16,7.33333333 L16,0.666666667 L16,0 L15.3333333,0 L0.666666667,0 L0,0 Z M1.33333333,1.33333333 L2,1.33333333 L2,2.66666667 L3.33333333,2.66666667 L3.33333333,1.33333333 L4.66666667,1.33333333 L4.66666667,4 L6,4 L6,1.33333333 L7.33333333,1.33333333 L7.33333333,2.66666667 L8.66666667,2.66666667 L8.66666667,1.33333333 L10,1.33333333 L10,4 L11.3333333,4 L11.3333333,1.33333333 L12.6666667,1.33333333 L12.6666667,2.66666667 L14,2.66666667 L14,1.33333333 L14.6666667,1.33333333 L14.6666667,6.66666667 L1.33333333,6.66666667 L1.33333333,1.33333333 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.2a857d6a2111be84a215dd7cb94b5adb.svg";
export { ForwardRef as ReactComponent };